import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import { Reveal } from "../lib/ui";

// SoccerBible's ranked-list format, borrowed for the numbers rather than the boots.
export const RankedTen = () => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/ten-numbers").then((r) => setD(r.data)).catch(() => setErr("We could not load the count. Refresh to try again."));
  }, []);

  if (err)
    return (
      <section className="border-t border-zinc-900 bg-black py-16" data-testid="home-ranked-ten-error">
        <p className="mx-auto max-w-[1500px] border border-maasai/40 bg-maasai/10 p-6 text-sm text-white">{err}</p>
      </section>
    );
  if (!d) return null;

  return (
    <section className="border-t border-zinc-900 bg-black py-16 md:py-24" data-testid="home-ranked-ten">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <Reveal>
          <div className="flex items-end justify-between gap-6 border-b border-white/20 pb-4">
            <div>
              <p className="eyebrow">The count</p>
              <h2 className="display-2 mt-4 max-w-3xl">{d.title}</h2>
            </div>
            <span className="mono hidden shrink-0 text-[0.6rem] uppercase tracking-[0.18em] text-zinc-400 md:block">
              10 / 10
            </span>
          </div>
          <p className="body-copy mt-6 max-w-2xl">{d.standfirst}</p>
        </Reveal>

        <div className="mt-10 border-t border-white/10">
          {d.items.map((it, i) => (
            <Link
              key={it.label}
              to={it.to}
              data-testid={`ranked-ten-row-${i + 1}`}
              className="group grid grid-cols-[44px_minmax(0,1fr)] items-start gap-5 border-b border-white/10 py-6 transition-colors hover:bg-[#0d0d0d] md:grid-cols-[72px_minmax(0,26%)_minmax(0,1fr)_auto] md:items-center md:gap-8"
            >
              <span className="mono text-sm text-maasai md:text-base">{String(i + 1).padStart(2, "0")}</span>
              <span className="mono text-2xl font-bold text-ochre md:text-3xl">{it.value}</span>
              <span className="col-span-2 md:col-span-1">
                <span className="block font-display text-lg uppercase leading-tight tracking-tight text-white transition-colors group-hover:text-ochre md:text-xl">
                  {it.label}
                </span>
                <span className="mt-2 block text-sm leading-relaxed text-zinc-400">{it.detail}</span>
              </span>
              <ArrowUpRight
                size={16}
                className="hidden shrink-0 text-zinc-400 transition-colors group-hover:text-maasai md:block"
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
